import { render } from "./DashboardBoxList.vue?vue&type=template&id=26c19c80"
import script from "./DashboardBoxList.vue?vue&type=script&lang=js"
export * from "./DashboardBoxList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__